/**
 *
 * Select
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import SelectWrapper from './styles/SelectWrapper';
import Label from 'components/Label';
import SelectInput from './styles/SelectInput';
import SelectInputError from './styles/SelectInputError';

class Select extends React.PureComponent {
  constructor() {
    super();

    this.setOption = this.setOption.bind(this);

    this.state = {
      selected: ''
    };
  }

  setOption(event) {
    this.setState({ selected: event.target.value });
    this.props.sendDataCallback(event.target.value);
  }

  render() {
    const { options, label, isRequired, isSalaryRange, showError, value } = this.props;
    
    let { selected } = this.state;

    if(value){
      selected = value;
    } else {
      selected = "";
    }

    const optionsContent = options
      ? options.map((option, index) => {
          return <option key={`${label}-${index}`}>{option.charAt(0).toUpperCase() + option.slice(1)}</option>;
        })
      : [];

    return (
      <SelectWrapper className="select-wrapper">
        {label ? <Label title={label} isRequired={isRequired} /> : ''}
        <div className="select-container">
          <img src="/assets/img/arrow-down.svg" alt="Down" />
          <SelectInput value={selected} disabled={this.props.disabled} onChange={this.setOption} showError={showError} noValue={!selected}>
            {
              <option value={''} disabled>
                {'Select from the list...'}
              </option>
            }
            {optionsContent}
            {!isRequired && !isSalaryRange ? <option value={''}>{'Other'}</option> : ''}
          </SelectInput>
        </div>
        <SelectInputError showError={showError}>Oops! Something is missing...</SelectInputError>
      </SelectWrapper>
    );
  }
}

Select.propTypes = {
  options: PropTypes.array,
  sendDataCallback: PropTypes.func
};

export default Select;
